import React from "react";
import { Route } from "react-router-dom";
import useUserStore from "../../stores/user";
import NotFound from "../NotFound";

const PCAdminRoute = ({ component: Component, render, children, ...rest }) => {
  const isPCAdmin = useUserStore((state) => state.isPCAdmin);
  const userLoading = useUserStore((state) => state.userLoading);

  if (children) {
    return (
      <Route {...rest}>
        {userLoading ? null : isPCAdmin ? children : <NotFound />}
      </Route>
    );
  }

  return (
    <Route
      {...rest}
      render={(props) => {
        if (userLoading) {
          return null;
        }
        if (!isPCAdmin) {
          return <NotFound />;
        }
        if (Component) {
          return <Component {...props} />;
        }
        if (render) {
          return render(props);
        }
        return null;
      }}
    />
  );
};

export default PCAdminRoute;
